import { compose } from 'redux'

// higher-order components
import withQueryResults from 'components/shared/withQueryResults'
import withPathname from 'components/shared/withPathname'
import withQuery from './withQuery'

// presentational component
import UI from './UI'

export default compose(
  withQueryResults, // for handling query errors
  withPathname, // for nav
  withQuery // for fetching current logged in user
)(UI)
